<template>
  <div class="view-sharing__option">
    <SwitchInput small :value="view.show_logo" @input="guardar($event)">
      <!--
        El monograma MG que Caddy sirve como favicon. El icono de Baserow que
        iba aqui salia por /_nuxt/ y Caddy no lo cambia; y el baserow-icon.svg
        nuestro tiene el recorte malo ("A/G", ver branding/favicon-origen.md).
      -->
      <img
        class="switch__icon"
        src="/img/favicon_32.png"
        width="14"
        height="14"
      />
      <span>Mostrar el logo de Mandala Group</span>
    </SwitchInput>
  </div>
</template>

<script>
import SwitchInput from '@baserow/modules/core/components/SwitchInput'
import { notifyIf } from '@baserow/modules/core/utils/error'

/**
 * Quitar el "Powered by Baserow" de las vistas compartidas.
 *
 * `show_logo` es un campo del core y esta en los allowed_fields del ViewHandler,
 * pero NO en los `fields` de UpdateViewSerializer: el endpoint estandar de
 * vistas lo descarta en silencio —responde 200 y no cambia nada—. Por eso va
 * por un endpoint propio, /api/extras-mg/vista/<id>/logo/, y no por el de
 * premium.
 *
 * El interruptor va derecho: encendido = el logo se ve. El de premium lo lleva
 * al reves (`:value="!view.show_logo"`) con la etiqueta "Baserow logo", que se
 * lee como si encendido fuera mostrarlo.
 *
 * Y el contenedor NO lleva @click: con el, ese clic y el @input del switch se
 * disparan los dos y el valor se alterna dos veces, o sea se queda igual.
 */
export default {
  name: 'OpcionQuitarLogo',
  components: { SwitchInput },
  props: {
    view: { type: Object, required: true },
  },
  methods: {
    async guardar(mostrar) {
      // Se actualiza en pantalla antes de la respuesta y se revierte si falla:
      // un interruptor que tarda medio segundo en moverse se siente roto.
      this.$emit('update-view', { ...this.view, show_logo: mostrar })
      try {
        await this.$client.patch(
          `/extras-mg/vista/${this.view.id}/logo/`,
          { show_logo: mostrar }
        )
      } catch (e) {
        this.$emit('update-view', { ...this.view, show_logo: !mostrar })
        notifyIf(e, 'view')
      }
    },
  },
}
</script>
